import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Rols } from '../entities/rols.model';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class RolsService {
    readonly BASE: any = PETICIONES.rols;

    constructor(private http: HttpClient) { }

  /**
  * @description
  * Obtiene todos los rols
  */
  public findAll(): Observable<any> {
    return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
  }

  /**
  * @description
  * Obtiene un rols por su id
  */
  public findById(id: number): Observable<any> {
    let idrols: string = (id !== undefined && id !== null ? id + "" : "");
    return this.http.get(this.BASE.findById + "/" + idrols).pipe(delay(DELAY));
  }

  /**
  * @description
  * Guarda un rol interno en la base de datos
  */
  public postRolsInternal(rol: Rols): Observable<any> {
    const json = JSON.stringify(rol);
    const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
    return this.http.post(this.BASE.postRolsInternal, json, {headers: headers}).pipe(delay(DELAY));
  }

/**
* @description
* Borra un rol interno en la base de datos
*/
 public deleteRolsInternal(rol: Rols): Observable<any> {
    let coderol: string = (rol.code !== undefined && rol.code !== null ? rol.code + "" : "");
    return this.http.get(this.BASE.deleteRolsInternal + "/" + coderol).pipe(delay(DELAY));
}

}